export const RETURNS_GRID_SET_IS_LOADING = 'RETURNS_GRID_SET_IS_LOADING';
export const setIsLoading = (isLoading) => ({
  type: RETURNS_GRID_SET_IS_LOADING,
  isLoading,
});

export const RETURNS_GRID_CHANGE_PAGE = 'RETURNS_GRID_CHANGE_PAGE';
export const changePage = (newPage, pageSize) => ({
  type: RETURNS_GRID_CHANGE_PAGE,
  newPage,
  pageSize,
});

export const RETURNS_GRID_OPEN_SET_RECEIVED_DATE_MODAL = 'RETURNS_GRID_OPEN_SET_RECEIVED_DATE_MODAL';
export const openSetReceivedDateModal = () => ({
  type: RETURNS_GRID_OPEN_SET_RECEIVED_DATE_MODAL,
});

export const RETURNS_GRID_OPEN_UPDATE_RECEIVED_DATE_MODAL = 'RETURNS_GRID_OPEN_UPDATE_RECEIVED_DATE_MODAL';
export const openUpdateReceivedDateModal = () => ({
  type: RETURNS_GRID_OPEN_UPDATE_RECEIVED_DATE_MODAL,
});

export const RETURNS_GRID_MARK_AS_RECEIVED_SUCCESS = 'RETURNS_GRID_MARK_AS_RECEIVED_SUCCESS';
export const markAsReceivedSuccess = () => ({
  type: RETURNS_GRID_MARK_AS_RECEIVED_SUCCESS,
});

export const RETURNS_GRID_PRINT_LABEL = 'RETURNS_GRID_PRINT_LABEL';
export const printLabel = () => ({
  type: RETURNS_GRID_PRINT_LABEL,
});

export const RETURNS_GRID_REFRESH_TRACKING = 'RETURNS_GRID_REFRESH_TRACKING';
export const refreshTracking = () => ({
  type: RETURNS_GRID_REFRESH_TRACKING,
});

export const RETURNS_GRID_VOID_AND_CANCEL_RETURN = 'RETURNS_GRID_VOID_AND_CANCEL_RETURN';
export const voidAndCancelReturn = () => ({
  type: RETURNS_GRID_VOID_AND_CANCEL_RETURN,
});

export const RETURNS_GRID_CHANGE_COLUMNS = 'RETURNS_GRID_CHANGE_COLUMNS';
export const returnsGridChangeColumns = (statusViewId, columns) => {
  const statefulConfig = columns.map((c) => ({
    id: c.id,
    index: c.index,
    width: c.width,
    pinned: c.pinned,
    sorted: c.sorted,
  }));
  return {
    type: RETURNS_GRID_CHANGE_COLUMNS,
    statusViewId,
    columns: statefulConfig,
  };
};

export const RETURNS_GRID_CHANGE_ORDERBY = 'RETURNS_GRID_CHANGE_ORDERBY';
export const returnsGridChangeOrderBy = (statusViewId, columns) => {
  const statefulConfig = columns.map((c) => ({
    id: c.id,
    index: c.index,
    width: c.width,
    pinned: c.pinned,
    sorted: c.sorted,
  }));
  return {
    type: RETURNS_GRID_CHANGE_ORDERBY,
    statusViewId,
    columns: statefulConfig,
  };
};
